// ja.js — auto-generated translation. Source: ./en.js
const ja = {
  meta: {
    backToHome: "ホームへ戻る",
    lastUpdated: "最終更新日：2026年4月8日",
  },

  mentionsLegales: {
    title: "法的通知",
    seoTitle: "法的通知 | Lumina Wallet",
    seoDescription: "Lumina Wallet 法的通知。ウェブサイトの発行者、ホスティング、および法的義務に関する情報。",
    body: `## 1. ウェブサイト運営者

2004年6月21日付デジタル経済の信頼に関する法律第2004-575号（LCEN）第6条に基づき、ウェブサイト luminawallet.org の利用者に対し、その作成および監視に関わる関係者の身元を以下の通り通知します。

- **会社名:** HEDONISME SARL
- **法的形態:** 有限責任会社 (SARL)
- **資本金:** 64,000.00 EUR
- **登録事務所:** 933 Route Departementale, Zone Artisanale la Houblonniere, 59270 Meteren, France
- **登録:** RCS Dunkerque 901 439 505
- **登録日:** 2021/07/15
- **共同体域内VAT番号:** FR43 901 439 505
- **事業内容:** 事業その他の経営コンサルタント業 — NAF/APE コード: 70.22Z
- **公開責任者:** Stéphane Anthoniak, HEDONISME SARLの代表取締役
- **連絡先メールアドレス:** support@luminawallet.org
- **ウェブサイト:** https://luminawallet.org

## 2. ホスティングプロバイダー

ウェブサイト luminawallet.org は以下の事業者によってホストされています。

- **会社名:** Vercel Inc.
- **住所:** 440 N Barranca Ave #4133, Covina, CA 91723, United States
- **連絡先:** privacy@vercel.com

本サイトは Vercel によってホストされています。ホスティングに関連するデータ処理を規制するため、技術的、組織的、契約的な措置が講じられています。ホスティング事業者の利用のみでは、GDPR への全体的な準拠は保証されません。

## 3. 知的財産

ウェブサイト luminawallet.org および Lumina Wallet アプリケーションに存在するすべてのコンテンツ（グラフィック、画像、テキスト、ビデオ、アニメーション、サウンド、ロゴ、GIF、アイコン、およびそれらのフォーマットを含むがこれに限定されない）は、他の提携会社または著作者に属する商標、ロゴ、またはコンテンツを除き、HEDONISME SARL の独占的財産です。

これらの異なる要素のいかなる複製、配布、改変、翻案、再送信、または公開（部分的であっても）も、HEDONISME SARL の書面による明示的な同意なしには厳しく禁止されています。いかなる手段によるものであれ、この表現または複製は、フランス知的財産法典L.335-2条以下により処罰される侵害を構成します。

## 4. 責任の制限

HEDONISME SARL は、luminawallet.org ウェブサイト上で可能な限り正確な情報を提供するよう努めています。しかし、当社は、自社または情報を提供する第三者の提携者によって引き起こされた、情報の欠落、不正確さ、および更新の不備について責任を負うことはできません。

ウェブサイトに記載されているすべての情報は目安として提供されており、変更される場合があります。さらに、ウェブサイトの情報は網羅的ではありません。

**リスク警告:** 暗号資産は非常にボラティリティの高い資産です。その価値は大幅に変動する可能性があります。暗号資産への投資は、元本を失う高いリスクを伴います。Lumina Wallet は厳密には非管理型のソフトウェア管理ツールであり、金融、法律、または投資に関する助言を提供するものではありません。利用者は、自身の投資判断および秘密鍵/リカバリーフレーズのセキュリティに対して単独で責任を負います。

## 5. 個人データ保護 (GDPR)

フランスでは、個人データは特に1978年1月6日付法律第78-87号、2004年8月6日付法律第2004-801号、刑法典L.226-13条、および1995年10月24日付欧州指令（GDPR）によって保護されています。

お客様のデータの収集、使用、保護方法に関する詳細については、当社のプライバシーポリシーをご参照ください。

## 6. ハイパーテキストリンクとCookie

luminawallet.org ウェブサイトには、HEDONISME SARL の許可を得て設定された、他のサイトへの多数のハイパーテキストリンクが含まれている場合があります。しかし、HEDONISME SARL は、訪問されたこれらのサイトのコンテンツを検証する可能性を持たないため、この事実に関して一切の責任を負いません。

サイトの閲覧は、利用者のコンピューターへのCookieのインストールを引き起こす可能性があります。Cookieの使用に関する詳細については、当社のプライバシーポリシーをご参照ください。

## 7. 準拠法と管轄

luminawallet.org ウェブサイトまたは Lumina Wallet アプリケーションの使用に関連する紛争は、フランス法に準拠します。法律で認められない場合を除き、専属的管轄権はフランス、パリの管轄裁判所に与えられます。

## 8. 消費者調停

消費者調停の取扱いは現在、法的検討中です。苦情等については contact@luminawallet.org までお問い合わせください。本文言は、専門家の意見を踏まえて更新される予定です。

> 本翻訳は情報提供のみを目的として提供されます。解釈に齟齬が生じた場合は、フランス語版が優先されます。
`,
  },

  politiqueConfidentialite: {
    title: "プライバシーポリシー",
    seoTitle: "プライバシー通知 | Lumina Wallet",
    seoDescription: "Lumina Wallet プライバシー通知。当社がお客様の個人データをどのように収集し、処理するかについてご確認ください。",
    body: `本プライバシー通知（以下「本通知」といいます）は、Lumina Wallet（以下「Lumina Wallet」、「当社」、「弊社」、「我々」、「自己」といいます）が、当社のウェブサイト（https://luminawallet.org/）およびアプリケーション、その他のサービス（当社のウェブサイトおよびアプリと総称して、以下「当社のサービス」といいます）を通じて、お客様の個人データ（以下「お客様」といいます）をどのように収集および処理するかを説明するものです。さらに、該当する場合、当社は、お客様の求職応募の処理またはお客様の当社での雇用管理など、特定の目的のためにお客様の個人データを処理することもあります。当社のサービスを利用するか、当社と関わることにより、お客様は本プライバシー通知に記載されたお客様の個人データの収集、保存、処理、および移転に同意するものとします。

本プライバシー通知は、当社の利用規約、当社の事業条件、またはその他の契約文書（お客様との間で締結する可能性のあるあらゆる契約を含むがこれに限定されない）と併せて適用されます。

## 1. お客様との関係

お客様のプライバシーの権利および個人データの保護は、当社にとって重要です。Lumina Walletは、プライバシーにおける最善の慣行に取り組んでおり、当社のサービスを提供するために厳密に必要である場合にのみデータを収集します。

Lumina Walletのサービス（例として、当社のウェブサイトへの訪問、当社のアプリケーションの使用、ソーシャルメディアまたはコミュニティフォーラムでの交流、当社のオフラインイベントへの参加など、このリストは網羅的なものではありません）を利用することにより、お客様は本プライバシー通知に定める利用、開示、および手続を認識し、承諾するものとします。

以下のセクションでは、データ管理者としてLumina Walletを通じてお客様の個人データを処理する方法について、さらに詳細に説明します。

## 2. お客様の個人データの収集と利用

「個人データ」とは、個人を識別できる情報、または識別可能な個人に関連する情報です。これには、お客様が自発的に当社に提供する情報、当社のサービス提供の通常の過程で自動的に収集または作成される情報、またはお客様が当社に連絡する際に提供される情報が含まれます。データ最小化など、プライバシーにおける最善の慣行に従い、当社は、ユーザーに当社のサービスを提供するために必要な量の個人データのみを収集するよう努めます。

### お客様が当社のセルフカストディウォレットを使用する場合

アプリまたはブラウザ拡張機能のいずれかを通じて、当社のウォレットアプリケーションのユーザーとして、お客様はウォレット情報を生成またはインポートするオプションがあり、これはお客様のデバイスにローカルに保存されます。当社は、この目的のために電子メールアドレスやその他の個人データのカテゴリを収集することはありません。

以下に、アプリケーションが使用する個人データと、その情報を処理する目的を概説する表を示します。

| 個人データの種類 | 個人データの具体例 | 処理の目的および法的根拠 |
|---|---|---|
| **ウォレット情報** | ウォレット秘密鍵および公開ウォレットアドレス。ウォレット情報はお客様の管理下でデバイスにローカルに保存されることにご注意ください。 | 当社は、セルフカストディ型暗号ウォレットサービスを提供し、お客様が要求する取引を促進、実行、および管理するために、お客様のウォレット情報および取引情報を処理します。この処理の法的根拠は、お客様が当事者である契約の履行に不可欠であることです。 |
| **取引情報** | タイムスタンプ、公開ウォレットアドレス、取引金額など、お客様が公開ブロックチェーン上で行った過去の取引に関する情報。 | 当社は、セルフカストディ型暗号ウォレットサービスを提供し、お客様が要求する取引を促進、実行、および管理するために、お客様の取引情報を処理します。この処理の法的根拠は、お客様が当事者である契約の履行に不可欠であることです。 |
| **デバイスおよび利用状況に関する情報** | デバイスモデル、オペレーティングシステム、アプリのインストール情報、ブラウザの種類および言語設定。IPアドレスは一時的な目的でのみ使用され、いかなるユーザーの個人データにも関連付けられず、保持されないことにご注意ください。 | 当社は、お客様のデバイスおよび利用状況に関する情報を使用して、当社サービスを提供および強化し、お客様がより良いユーザーエクスペリエンスを享受できるようにします。この処理の法的根拠は、当社サービスの改善およびユーザーエクスペリエンスの向上における当社の正当な利益を満たすために必要であることです。 |

### お客様が当社のウェブサイトを訪問する場合

お客様が当社のウェブサイトを利用したり、当社のブログを閲覧したり、カスタマーサポートを要求したり、当社のコミュニティフォーラムやキャンペーンに参加したりする場合、個人データを提供することがあります。この目的のために、当社はお客様のウォレット情報を要求しないことにご注意ください。

| 個人データの種類 | 個人データの具体例 | 処理の目的および法的根拠 |
|---|---|---|
| **連絡先情報** | お客様が当社のウェブサイト上での当社とのやり取りにおいて提供を選択する情報（電子メールアドレスなど）。 | 当社は、カスタマーサポートおよび支援目的でお客様と連絡を取るために、お客様の連絡先情報を処理します。この処理の法的根拠は、お客様が当事者である契約の履行に不可欠であることです。 |
| **ソーシャルメディア情報** | お客様がX、Telegramなどのソーシャルメディアチャネルを通じて当社とのやり取りにおいて提供を選択する情報。 | 当社は、ソーシャルメディアチャネルでの最新の発表についてお客様を更新するために、お客様のソーシャルメディア情報を使用します。当社は、当社とのやり取りのために個人データを処理することについてお客様の同意に依拠します。お客様はいつでも同意を撤回することができます。 |
| **プロフィール情報** | お客様が当社のオンラインコミュニティフォーラムでプロフィールを作成する際に提供を選択する情報（電子メール、ユーザー名、プロフィール写真など）。 | 当社は、コミュニティフォーラムプラットフォームでのログインを可能にし、メンバー間の交流を促進するために、お客様のプロフィール情報を処理します。この処理の法的根拠は、お客様が当事者である契約の履行に不可欠であることです。 |
| **デバイスおよび利用状況に関する情報** | デバイスモデル、オペレーティングシステム、ブラウザの種類、アプリケーションバージョン、タイムゾーン、言語設定などのインターネット接続データ。IPアドレスは一時的な目的でのみ使用されることにご注意ください。 | 当社は、お客様のデバイスおよび利用状況に関する情報を使用して、当社サービスを提供および強化し、お客様がより良いユーザーエクスペリエンスを享受できるようにします。この処理の法的根拠は、当社サービスの改善およびユーザーエクスペリエンスの向上における当社の正当な利益を満たすために必要であることです。 |

### 採用と雇用

お客様が当社での職に応募するか、当社に雇用される場合、当社は、採用、オンボーディング、雇用管理、法的義務の遵守、およびその他の雇用関連活動を含む目的のために、お客様の個人データを収集および処理します。個人データは、お客様から直接、第三者の採用エージェンシーから、またはLinkedInなどの公開情報源から収集される場合があります。

当社は、採用および雇用目的で以下の種類の個人データを処理します。

1. **連絡先情報：** 当社は、お客様の職務応募および該当する場合は雇用についてお客様と連絡を取るために、お客様の氏名、電子メールアドレス、およびその他の関連する連絡先の詳細を収集します。
2. **学歴および職歴情報：** 当社は、お客様の履歴書（CV）、職務経歴書、LinkedInプロフィール、学業証明書および成績証明書、職歴、ならびに（関連する場合）給与およびボーナスの詳細を収集します。当社は、お客様の適格性を評価し、応募を処理し、背景調査を実施し、雇用関係を管理するためにこの情報を使用します。

採用活動中、当社は、お客様の個人データを処理することについてお客様の同意に依拠します。雇用された後は、当社は、お客様の契約を履行する必要性、法的義務を遵守する必要性、および雇用関係を管理することにおける当社の正当な利益に依拠します。当社がお客様に職を提供できない場合、当社は、将来の職務でお客様を検討することにおける当社の正当な利益に基づき、お客様が異議を申し立てない限り、お客様の個人データを最大2年間保持することがあります。

### 当社のイベントへの参加

お客様が当社のイベントに登録または参加する場合、当社は、お客様の参加を管理するために一部の個人データを収集します。これには、お客様の氏名、連絡先の詳細、会社情報、役職、業界、所在地、LinkedInプロフィール、支払い詳細、および請求先住所が含まれる場合があります。

当社は、この情報を以下の目的で使用します。

1. お客様のイベント登録とチケット発行を処理する
2. イベントに関する重要な更新を通知する
3. 将来のイベントを改善するために参加状況を分析する

当社は、お客様が登録時に締結する契約に基づき、またイベントの提供および改善における当社の正当な利益に基づき、お客様の個人データを処理します。イベント中にプロモーションおよび記録保存目的で写真撮影およびビデオ撮影が行われる場合があることにご注意ください。当社のイベントに参加することにより、お客様は、Lumina Walletおよび当社のパートナーが、マーケティング資料、ソーシャルメディア投稿、または将来のイベントプロモーションでお客様の画像を使用することに同意します。

### プッシュ通知

当社は、お客様の関心に関連するアラート、更新、またはニュースを提供するために、当社のアプリを通じてオプションのプッシュ通知を送信することがあります。これらの通知は、お客様の選択に基づいて送信され、お客様はアプリ内の通知設定を通じていつでもこれらを管理または撤回することができます。

### 生体認証（Face IDおよび指紋スキャン）

当社は、ウォレットにログインするための安全で便利な方法として、オプションの生体認証（Face IDや指紋認識など）を提供します。お客様が生体認証を有効にすることを選択した場合、お客様の生体データは、モバイルオペレーティングシステムの内蔵セキュリティ機能を使用して、お客様のデバイス上で直接処理されます。お客様の生体認証情報が当社のサーバーまたは第三者に送信されることはありません。

### 当社のAIサービスとの連携

お客様が当社のAIチャットボットなどの人工知能（以下「AIサービス」といいます）を伴う当社のサービスを使用する場合、当社は、お客様が選択したAI機能に応答し、提供できるように、お客様が入力またはフィードバックとして提供するコンテンツを処理します。

**音声入力（オプション）：** 利用可能な場合、お客様は音声入力を使用してAIサービスと連携することを選択できます。お客様の音声は、テキスト転写を作成するためにリアルタイムで処理され、その後、他のテキストベースの入力と同様に処理されます。

当社は、お客様が要求するAIサービスを提供するために必要であるため、契約の履行に基づいてこのコンテンツを処理します。これらの機能を提供するために、当社は当社の指示に基づいて行動する信頼できる第三者のAIサービスプロバイダーを利用することがあります。彼らは契約上および秘密保持義務に拘束されており、自身の目的のために顧客のデータを使用することは許可されていません。

### お客様から自動的に収集される個人データ

特定の状況において、当社は、適用法に従い、お客様が当社のサービスを利用する際に、お客様から個人データを自動的に収集することがあります。これには、お客様のエクスペリエンスを向上させ、カスタマーサポートを提供し、当社のサイトおよびサービスのパフォーマンスを改善し、不正アクセスを検出して詐欺を防止することにより、お客様のアカウントを保護するのに役立つデバイス、ログ、および利用状況に関するデータが含まれる場合があります。

お客様が当社のセルフカストディウォレットを使用するか、当社のウェブサイトを訪問する場合、お客様のIPアドレスは一時的な目的で処理されることがあります。この限定的な処理は、(a) 規制要件に従ってトラフィックをルーティングし、サービスローカリゼーションを促進するため、および (b) お客様が第三者プラットフォームと接続することを選択した場合に、それらとの安全な接続を確立するため、にのみ使用されます。お客様のプライバシーは常に保護されており、当社は、これらの一時的な使用を超えて、お客様のIPアドレスをログに記録、保持、またはその他の方法でアクセスすることはありません。

### 集計データおよび匿名化データ

当社は、当社のサービスを改善するために、集計データまたは匿名化データも使用します。これには、個々のユーザーを特定することなく、一般的な利用傾向を分析し、フィードバックを収集し、調査を実施することが含まれます。当社は、当社のサービスのパフォーマンスを実証し、事業開発を支援し、または戦略的決定に情報を提供する目的で、そのような集計データまたは匿名化データを信頼できるサービスプロバイダー、ビジネスパートナー、またはその他の第三者と共有または開示することもあります。

当社は、法的に要求または許可される場合、またはお客様自身の重大な利益のために行う場合を除き、お客様に通知された目的と両立しない目的でお客様の個人データを使用することはありません。
## 3. クッキーの使用

当社は、ユーザーエクスペリエンスを向上させ、サービスを提供し、マーケティング活動を強化し、お客様が当社のサービスをどのように利用しているかを理解して改善を行うために、クッキーおよび類似のツールを使用します。お客様が所在する地域の適用法令に基づき、お客様のブラウザのクッキーバナーが、クッキーの承諾または拒否方法をご案内します。

## 4. データの共有方法とその理由

当社のユーザーに関する情報は当社の事業の重要な一部であり、当社はユーザーの個人データを他者に販売する事業を営んでいません。Lumina Walletの一部の機能は、様々な第三者製品およびサービス（総称して「第三者サービス」）に依拠しているため、当社は、Lumina Walletの事業運営に関連して、個人データを当社のサービスプロバイダーまたは第三者に移転する場合があります。

第三者サービスプロバイダーは、その機能を実行し、サービスを提供するために、お客様の公開ウォレットアドレスなどの個人データにのみアクセス可能であり、他の目的でこれを使用することはできません。

当社は、以下の者と、または以下の状況において、個人データを共有することもあります。

- **事業移転：** 当社が事業を発展させるにつれて、他の事業やサービスを売却または買収する可能性があります。そのような取引において、ユーザー情報は通常、移転される事業資産の一つとなりますが、既存のプライバシー通知における約束に従います。
- **法的機関：** 当社は、法律または裁判所の命令により、関連する規制当局、法執行機関、および／またはその他の管轄当局に特定の情報を開示するよう求められる場合があります。当社は、法律に従って義務付けられている範囲で、法的機関に個人データを開示します。
- **当社および他者の保護：** 当社は、適用される法令、規制、法的手続き、または強制力のある政府の要請を遵守するため、法執行機関に協力するため、当社の利用規約およびその他の契約を執行または適用するため、あるいはLumina Wallet、当社の従業員、当社のユーザー、または他者の権利、財産、または安全を保護するために、当該情報へのアクセス、利用、保存、または開示が合理的に必要であると合理的に判断する場合、Lumina Walletの外部に個人データを共有します。

当社のサービスおよびウェブサイトには、様々な第三者のウェブサイト、アプリケーション、その他の外部プラットフォームと接続するためのリンクが含まれている場合があります。これらの第三者プラットフォームは、独立したデータ管理者として機能し、お客様の個人データの処理は、それぞれのプライバシー通知およびポリシーに従うものとします。本プライバシー通知は、これらの第三者プラットフォームのプライバシー慣行を対象とするものではありません。

## 5. 個人データの国際移転

当社は、信頼できるサービスプロバイダーがホストするサーバーを維持しており、お客様の情報は、お客様の居住国以外のサーバーで処理される場合があります。当社がお客様の個人データを国外のサーバーで処理する場合、または第三国に移転する場合、お客様の個人データが保護された状態を維持するために、適切な技術的、組織的、および契約上の保護措置を講じます。これには、標準契約条項の使用が含まれますが、これに限定されません。

## 6. データセキュリティ

当社は、情報セキュリティがデータプライバシーの重要な要素であることを認識しています。当社は、お客様の情報が適用される法令および当社のデータプライバシーポリシーに従って保護されるよう努めます。いかなるデータ送信も完全に安全であると保証することはできませんが、当社は、個人データへの不正アクセス、使用、開示、改ざん、または破壊から保護するために、商業的に合理的な物理的、技術的、および手続き上の様々な措置を採用しています。

お客様が自己管理型ウォレットユーザーである場合、ウォレット情報および秘密鍵はデバイスにローカルに保存され、お客様個人の管理下にありますのでご注意ください。ウォレット情報を保護するため、デバイスとウォレットアプリケーションの両方でアクセス制御とパスコードが有効になっていることを確認してください。

## 7. データ保持

当社は、お客様が引き続き当社のサービスを利用できるよう、本プライバシー通知に記載された関連目的を達成するために必要な期間、または税務・会計目的などの法的義務により要求される期間、あるいは紛争および／または法的請求を解決するために必要な期間、またはその他お客様に通知された期間、お客様の個人データを保持します。

お客様の個人データを保持する継続的な正当な事業上または法的な要件がない場合、当社はその情報を削除または匿名化します。それが不可能な場合は、削除が可能になるまで、お客様の個人データを安全に保管し、それ以降の処理から分離します。

お客様がLumina Walletモバイルアプリケーションからウォレットアドレスを削除したり、デバイスからアンインストールしたりした場合でも、個人データの削除権／消去権は、一部の状況において絶対的なものではないことにご注意ください。これは、ブロックチェーンが公開された分散型ネットワークであり、ブロックチェーン技術は一般的にデータの削除を許容しないためです。

## 8. お客様のプライバシー権

適用される法令に従い、お客様はご自身のプライバシーおよび個人データの保護に関して、いくつかの権利を有します。お客様は、ご自身の個人データへのアクセス、訂正、および削除を要求する権利、ならびにデータポータビリティを要求する権利を有します。さらに、お客様が特定の目的のために当社による個人データの処理に同意された場合、いつでもその同意を撤回することができます。

- **アクセス権：** お客様は、当社が保持するご自身の個人データのコピー、およびその処理に関する特定の情報を取得する権利を有します。
- **訂正権：** お客様は、不正確な個人データの訂正を要求することができ、また、ご自身の記録を補完するための追加情報を提供することもできます。
- **削除権：** お客様は、ご自身の個人データの削除を要求することができます。適用される法的義務を遵守するために、個人データを保持する必要がある場合があることにご注意ください。
- **異議申立権：** お客様は、ご自身の状況に関連する理由により、ご自身の個人データの処理に異議を申し立てることができます。
- **処理の制限権：** お客様は、正当な理由がある場合、特定のケースにおいて、当社による個人データの処理を一時的に制限する権利を有します。
- **同意の撤回権：** お客様は、同意を撤回し、当社がお客様の個人データを収集、使用、および／または開示することを停止するよう要求する権利を有します。この権利の行使は、撤回前に与えられた同意に基づく処理の合法性に影響を与えません。
- **データポータビリティ権：** お客様は、別のサービスプロバイダーに情報を送信できるよう、構造化された方法でお客様の情報を提供するよう当社に要求することもできます。

当社は、可能な限り迅速に対応します。当社が10営業日以内に対応できない場合、回答の期限を書面でお客様に通知します。
## 9. 児童

当社は、児童の個人情報に関して特に慎重に取り扱います。当社のサービスは児童を対象としておらず、当社のサービスをご利用いただくには、利用者は18歳以上である必要があります。当社は、18歳未満の者から意図的にデータを収集したり、マーケティング活動を行ったりすることはありません。万一、当社が18歳未満の者から個人データを収集したことが判明した場合、当社は当該アカウントを無効化し、かかるデータを当社の記録から速やかに削除するために合理的な措置を講じます。

## 10. 利用条件、通知および改訂

お客様が当社のサービスのご利用を選択された場合、お客様のご利用およびプライバシーに関する紛争は、本プライバシー通知および当社の利用規約に準拠します。当社は、いつでも本通知を更新および改訂する権利を留保します。当社は、適用される法令を遵守し、事業の変化に対応していることを確認するため、本プライバシー通知を随時見直します。当社が本プライバシー通知を改訂する場合、本通知冒頭の「最終更新日」を更新します。

お客様は、本プライバシー通知の条項を認識していることを確認するため、定期的に本プライバシー通知をご確認ください。当社のプライバシー通知の修正後もお客様が引き続き当社のサービスをご利用になることは、修正後の条項に同意したものとみなされます。

## 11. プライバシーチーム連絡先情報

プライバシーに関するご質問がある場合は、オンラインフォームを通じてお問い合わせください。その他のウォレットアプリ関連のお問い合わせおよびカスタマーサポートについては、**support@luminawallet.org**までお問い合わせください。

当社のプライバシー通知をお読みいただきありがとうございます！`,
  },

  cgu: {
    title: "利用規約",
    seoTitle: "利用規約 | Lumina Wallet",
    seoDescription: "Lumina Wallet 利用規約。当社のサービスをご利用になる前に、当社のサービス利用規約をお読みください。",
    body: `Lumina Walletおよび/またはその関連会社（以下「当社」）は、当社のウェブサイト luminawallet.org を通じてソフトウェアサービスを提供しています。当社は関連するモバイルアプリおよび製品（総称して「サービス」または「Lumina Wallet」）も有しています。当社のサービスを利用する前に、当社の利用規約（以下「本規約」）および当社のウェブサイトまたはモバイルアプリに関連するその他のポリシーまたは通知を注意深くお読みいただくことが重要です。

## 1. 利用規約への同意

当社のサービスのいずれかを利用することにより、お客様は、(i) 当社の本規約を読み理解していること、(ii) 本規約に従うことに同意すること、および (iii) 本規約を法的に受諾する資格があることを確認するものとします。お客様が本規約または当社が変更する内容に同意しない場合は、当社のサービスを利用しないでください。

ご注意ください。当社は、金融または投資に関する助言を提供しません。当社は、デジタル資産の取引または運用に関して一切の推奨を行うことなく、テクノロジーサービスを提供します。デジタル資産を用いた取引を行うかどうかの決定は、お客様自身が行う必要があることを忘れないでください。

## 2. プライバシーポリシー

当社がお客様の情報をどのように収集、使用、開示するかを理解するには、当社のプライバシー通知をご確認ください。当社のサービスを利用することにより、お客様は、当社が当社のプライバシー通知の条項に従ってお客様の情報（お客様が当社に提供する個人データを含む）を管理することを受諾し、同意するものとします。

## 3. 利用規約またはサービスへの更新

当社は、当社の単独の裁量により、本規約をいつでも更新または変更する権利を留保します。その場合、当社は、改訂された規約を当社のウェブサイトまたはモバイルアプリケーションに掲載するか、または当社が合理的とみなすその他の連絡方法によってお客様に通知します。かかる掲載された改訂規約は、別段の定めがない限り、直ちに発効します。

お客様は、かかる変更について自身に通知し、本規約の改訂版を受諾するかどうかを決定するために、定期的に当社のウェブサイトを確認する必要があります。お客様が本規約の更新または変更後も引き続きLumina Walletを利用する場合、お客様は改訂された規約を受諾したものとみなされます。お客様が本規約または本規約の更新もしくは変更に同意しない場合、お客様は当社のサービスへのアクセスまたは使用を中止しなければなりません。当社のサービスは常に進化しており、当社は、いつでも、事前の通知なく、当社の単独の裁量により、サービスのすべてまたは一部を変更または中止することができます。

## 4. 適格性

Lumina Walletを利用するための適格性：

- お客様は、18歳以上であり、本規約を締結する法的能力を有している必要があります。
- お客様が法人を代表して当社のサービスを利用する場合、お客様はさらに、当該法人がその設立地の管轄権の適用法の下で正式に組織され、有効に存続していること、およびお客様が当該法人を代表して行為することを正式に許可されていることを表明し、保証するものとします。
- お客様は、キューバ、イラン、北朝鮮、シリア、およびウクライナのクリミア、ドネツク、ルハンスク地域を含むがこれらに限定されない、米国により包括的に制裁を受けているいかなる管轄地の法律の下で設立された居住者、国民、または法人であってはなりません。
- お客様は、現在、米国政府（米国財務省外国資産管理局（「OFAC」）の特別指定国民および指定ブロック対象者リストならびに外国制裁回避者リスト、および米国商務省産業安全保障局（「BIS」）のエンティティリストを含む）、国連安全保障理事会、英国政府、欧州連合またはその加盟国、またはその他の関連する制裁当局によって維持されている禁止または制限されている人物のリストに載っていてはなりません。
- お客様は、お客様の管轄地の法律で許可されている場合にのみ、当社のサービスを利用できます。疑義を避けるため、お客様の当社のサービスの使用が違法であるか、その他適用される法律に違反するような州、国、地域またはその他の管轄地に居住している、またはその市民もしくは居住者である場合、当社のサービスを利用することはできません。

お客様は、本規約がお客様に適用されるすべての法律、規則、および規制に準拠していることを確認してください。お客様は、正当に取得した、正当にお客様に帰属する資金のみを使用して当社のサービスを利用することに同意します。Lumina Walletを利用することにより、お客様は、本規約に定めるすべての適格要件を満たしていることを表明し、保証するものとします。

上記の条件にかかわらず、当社は、特定の個人がLumina Walletにアクセスまたは利用することを禁止する絶対的な裁量を保持します。また、当社は、関連する法律、規制、および会社方針に従い、当社の適格性基準をいつでも変更する権利を留保することにご注意ください。

## 5. サービス

Lumina Walletは、暗号通貨、仮想商品、NFT（以下「デジタル資産」）などのデジタル資産を対象とした非カストディアル型デジタルウォレットソフトウェアとして機能します。これは、お客様、そしてお客様のみが、お客様のデジタル資産およびプライベートキーに対する完全な管理権と責任を負い、それによってウォレットアドレスからの取引を自律的に承認することを意味します。

Lumina Walletが非カストディアル型ウォレットソフトウェアとして機能するため、関連するすべての活動および潜在的な損失リスクは常にお客様の管理下に完全に置かれていることを十分に認識してください。Lumina Walletは、お客様に以下の機能を提供します。

- さまざまなデジタル資産を送受信できるウォレットアドレスと関連するプライベートキーを生成すること。
- モバイルアプリケーションに組み込まれたウェブブラウザを通じて、サードパーティの分散型アプリケーション（以下「DApp(s)」）およびサードパーティの分散型取引所（以下「DEX」）を探索および利用すること。
- 独立したサードパーティサービスプロバイダーによって提供されるDApp機能を利用して、デジタル資産のスワップまたは取引を行うこと。
- ステーキングサービス（以下「ステーキングサービス」）を通じて、特定のデジタル資産をサードパーティの「Proof of Stake」ネットワークに展開すること。
- 独立したサードパーティサービスプロバイダーによって提供されるデジタル資産の価格情報にアクセスすること。
- デジタル資産の取引データをLumina Walletがサポートするさまざまなブロックチェーンネットワークにブロードキャストすること。これにより、各ブロックチェーンベースのソフトウェアをローカルデバイスにダウンロードまたはインストールする必要性が排除されます。

Lumina Walletの機能およびサービスの利用は、ネットワークの変動性、サイバーセキュリティの脅威、市場のボラティリティを含む、デジタル資産の管理および取引活動に関連するリスクを受諾することに基づいていることを忘れないでください。
## 6. ウォレットアドレス、秘密鍵、およびバックアップ機能

お客様のウォレットに関連する特定の情報の暗号化されたバックアップは、対象となるデバイスに保存できます。ウォレットアドレスは秘密鍵とリンクしており、両方揃うことで、当該ウォレットアドレスからのデジタル資産の転送および当該ウォレットアドレスへのデジタル資産の転送を許可することができます。お客様は、お客様の秘密鍵およびウォレットに関連するニーモニックフレーズ（「シークレットフレーズ」）の保管とセキュリティについて単独で責任を負うものとします。

ウォレットアドレス、シークレットフレーズ、および秘密鍵へのアクセス情報を保護することが不可欠です。同様に、秘密鍵、バックアップフレーズ、またはパスワードのバックアップも非常に重要です。これらを怠ると、ウォレットに紐づくデジタル資産に対する権限を失う結果となる可能性があります。当社は、お客様のウォレットのパスワード、暗号化された秘密鍵、非暗号化された秘密鍵、またはお客様のウォレットに接続されたシークレットフレーズを取得または保持しないことにご留意ください。さらに、お客様がプライマリパスワードを忘れた場合、当社はお客様のウォレットの代替パスワードを生成することはできません。

お客様がウォレット内に存在する秘密鍵とウォレットアドレスのペアのバックアップを安全に保管していない場合、そのようなウォレットアドレスに関連するすべてのデジタル資産はアクセス不能になることを忘れないでください。したがって、当社は、お客様がウォレットアドレス、シークレットフレーズ、および秘密鍵情報を保護しなかったことを含むがこれに限定されない、いかなる理由でお客様がウォレットにアクセスできない場合においても、一切の責任を明示的に否認します。

お客様のデジタル資産を保護するには、お客様の最大限の注意と警戒が必要です。Lumina Walletの運営は、お客様がデジタル資産の重要性を十分に認識し、それらを保護するために必要な措置を実行するという原則に基づいています。お客様は、Lumina Wallet内で行ういかなる行動についても単独で責任を負うことに同意し、デジタル資産管理に伴うリスクを認識するものとします。

## 7. DAppsおよびDEXの利用

当社のサービス内での「デジタル資産の取引/スワップ」機能などのDApp機能を含むがこれに限定されない、分散型アプリケーション（DApps）または分散型取引所（DEX）にアクセスまたはこれらを利用する際、お客様は以下の条件を理解し、同意する必要があります。

- Lumina Walletは、お客様によるDAppsまたはDEXへの関与または利用を管理、推奨、または責任を負うものではありません。Lumina Walletは、紛争が発生した取引または損失につながる取引を含むがこれに限定されない、お客様のDAppsまたはDEXの利用に関連するいかなる責任または義務も負いません。
- お客様がDEXを通じて毎日取引できる金額は、スマートコントラクトの第三者開発者によって設定されたルールおよび制限に従います。Lumina Walletはこれらの制限を管理せず、その強制について責任を負いません。
- ブロックチェーン上でのすべての取引は最終的であり、取り消すことはできません。これは、DAppsまたはDEXを介して行われたいかなる取引も、お客様の完全な管理と責任の下にあることを意味します。お客様は、誤ったアドレスへの転送や選択したノードサーバーの問題を含むがこれに限定されない、これらの取引に関連するいかなる問題の結果についても全責任を負います。
- DAppsまたはDEXの利用には、第三者のスマートコントラクトに関連する手数料またはサービス料が発生する場合があります。これらの手数料は第三者開発者によって決定され、Lumina Walletが管理するものではありません。ユーザーは、取引を行う前に、第三者サービスプロバイダーが提供する手数料情報を確認する必要があります。Lumina Walletに表示されるこれらの手数料に関する情報は、参照目的のみです。Lumina Walletは、この情報の正確性、関連性、信頼性、完全性、または適合性を保証することはできず、お客様がこの情報を使用することから生じる直接的または間接的な損失または損害について責任を負いません。
- Lumina Walletは、将来的にその裁量で料金を導入する権利を留保します。いかなる手数料の更新も、更新された手数料が有効になった後に実行される取引に適用されます。ユーザーには、当社のウェブサイトまたはモバイルアプリケーションでの更新を含む、合理的な手段を通じてこれらの変更が通知されます。

Lumina Walletを通じてDAppsおよびDEXを使用することにより、お客様はこれらの関連リスクおよび潜在的な手数料を認識し、受け入れるものとします。Lumina Walletは、法的基準および規制を厳格に遵守するユーザーフレンドリーな環境を構築するよう努めています。これらの条件に同意することにより、お客様はセキュリティ、透明性、およびユーザーへの権限付与に対する当社のコミットメントを強化することになります。

## 8. ステーキングサービスの利用

お客様がステーキングサービスにアクセスまたは利用する場合、関連するブロックチェーンネットワーク上の取引を検証するために特定のデジタル資産（「ステーキングされたデジタル資産」）をステーキングする第三者プロバイダーと連携することになります。検証が成功すると、ネットワークが発行する報酬（「ステーキング報酬」）が得られる可能性があります。

ステーキングサービスを利用するにあたり、お客様は以下のことを認識し、同意するものとします。

- Lumina Walletは、お客様のステーキングサービスの利用を管理せず、その責任を負いません。当社は、ステーキングされたデジタル資産の損失、ステーキング報酬の取得の失敗、またはその過程で発生した手数料を含む、ステーキングサービスのお客様の利用に関連するいかなる潜在的な問題または損失についても、一切の責任を明示的に否認します。
- Lumina Walletは、ステーキング操作の中断がないことを保証することはできません。サービスの中断は、コードベースの更新、ネットワークプロトコルの変更、第三者プロバイダーの行動、ネットワーク混雑など、当社の制御を超える多くの要因によって発生する可能性があります。
- Lumina Walletは、特定のデジタル資産のステーキングまたは継続的なステーキングを保証することはできません。特定のデジタル資産をステーキングできるかどうかは、それぞれのブロックチェーンネットワークのルールおよび第三者ステーキングサービスプロバイダーの利用規約に基づいています。
- Lumina Walletは、関連するブロックチェーンネットワークによって提供されるステーキング報酬について、いかなる管理も責任も負いません。ステーキング報酬の分配に関する決定（頻度および金額を含む）は、Lumina Walletではなく、それぞれのネットワークのみに帰属します。
- Lumina Walletは、特定のデジタル資産またはステーキングサービスの潜在的な価値や適合性に関するアドバイスや予測を行うものではありません。ステーキングサービスを利用する決定はお客様自身のものであり、Lumina Walletはこれに関して一切の責任を負いません。
- Lumina Walletは、お客様のいかなる報酬または資産の保管をすることはありません。また、Lumina Walletがお客様によって委任された検証権限を行使する可能性のあるProof-of-Stakeネットワークについても、いかなる管理も行いません。
- Lumina Walletは、お客様がステーキング報酬または特定のステーキング報酬率を受け取ることを保証するものではありません。報酬の送金が成功するかどうかはProof-of-Stakeネットワークに依存しており、Lumina Walletの管理下にはありません。
- ステーキングサービスは「現状有姿」で提供されます。Lumina Walletは、サポートされているProof-of-Stake（POS）ネットワークによる報酬の送金の失敗、または誤ったウォレットアドレスへの送金や「スラッシング」（悪意のある行為や取引検証の失敗に対してネットワークによって課されるペナルティ）などの他のリスクによる報酬の損失について責任を負いません。
- Lumina Walletは、ステーキングサービスの中断のないまたはエラーのない操作を保証するものではなく、すべての欠陥を修正すること、または第三者または不正な第三者アクセスによって引き起こされる中断を防ぐことを保証するものでもありません。

ステーキングサービスを利用することを選択することにより、お客様はこれらの条件を認識するものとします。当社は、事前の通知なしにいつでもこのセクションを変更する権利を留保します。修正については、お客様が定期的にこのセクションを確認する責任があります。お客様がステーキングサービスを継続して利用することは、これらの条件およびその修正を受け入れることを意味します。
## 9. サポートされているクレジットカードまたはデビットカードによるデジタル資産の購入

Lumina Wallet を使用してクレジットカードまたはデビットカードでデジタル資産を購入することを選択した場合、選択された金額は該当するデジタル資産に変換され、第三者エンティティによってお客様のウォレットにクレジットされます。その際、お客様は以下の事項を認識し、同意することが重要です。

1. Lumina Wallet は、お客様によるこの第三者サービスの利用について責任を負わず、関連するいかなる責任も負いません。このプロセス中に発生した損失について、当社は責任を負いません。
2. このサービスを利用する場合、お客様は特定の第三者サービスプロバイダーが定めるすべての利用規約に拘束されます。Lumina Wallet はこれらの規約にいかなる影響も及ぼすことはできず、紛争が発生した場合でもお客様に代わって仲介することはできません。
3. お客様の要求が送信された後、Lumina Wallet は変換要求を改訂、撤回、またはキャンセルする権限または権限を有しません。取引は完全に Lumina Wallet の管理外にあります。
4. Lumina Wallet は、関連する第三者サービスプロバイダーが提供する為替レートについて、いかなる形でも責任を負いません。これには、取引後に発生する可能性のあるレートの変動が含まれます。
5. Lumina Wallet は、関連する第三者サービスプロバイダーまたはお客様の銀行もしくはクレジットカード発行会社によって課せられる手数料について責任を負いません。取引プロセス中に発生する追加料金は、すべてお客様のアカウントに帰属します。

Lumina Wallet を介してデジタル資産を購入することを選択することにより、お客様はこれらの条件を認識し、この種の取引に関連するすべてのリスクを負うことに同意するものとします。

## 10. デジタル資産取引

意図されたすべてのデジタル資産取引が実行されるためには、それぞれのデジタル資産の公開ブロックチェーンで検証され、記録される必要があります。これらのネットワークは、分散型およびピアツーピアであり、独立した第三者によって支えられており、Lumina Wallet の所有、管理、または運用下にありません。

Lumina Wallet はこれらのブロックチェーンネットワークを管理しておらず、したがって、当社のサービスを通じてお客様が提出するいかなる取引詳細の確認および実行も保証できません。Lumina Wallet を利用することを選択することにより、お客様は以下を認識し、同意する必要があります。

1. Lumina Wallet はお客様の取引をキャンセルまたは変更する機能を備えていません。
2. ブロックチェーンネットワークは、お客様が提出した取引詳細の完了を遅延させたり、失敗させたりする可能性があります。
3. Lumina Wallet はデジタル資産を保存、送信、または受信しません。関連するすべての活動は、該当するブロックチェーンプロトコルの枠組み内で完全に発生します。
4. いかなるデジタル資産に関連する転送も、Lumina Wallet が所有または運営するネットワークではなく、該当するブロックチェーンネットワーク上で処理されるため、Lumina Wallet はいかなるデジタル資産の所有権または権利の移転も保証できません。

Lumina Wallet のサービスを利用することにより、お客様は取引プロセスおよびデジタル資産の不安定な性質に関連するすべての固有のリスクを受け入れるものとします。

## 11. ユーザーによって提供される情報の正確性

お客様は、サービスを通じて提供する情報が正確かつ包括的であることを表明し、保証します。お客様は、サービスを通じて開始されたデジタル資産取引においてお客様が行ったいかなる誤りまたは不作為についても、当社が責任を負わないことを承諾し、理解します。潜在的な問題を避けるため、デジタル資産の転送を開始する前に、取引の詳細を綿密に確認することを強くお勧めします。

## 12. ウォレットの登録とセキュリティ

Lumina Wallet を利用するには、既存のウォレットをインポートするか、新しいウォレットを作成する必要があります。ウォレットの作成時に、お客様のために秘密鍵が生成されます。お客様の秘密鍵の不正使用またはウォレットに関連するその他のセキュリティ侵害が発生した場合、お客様は直ちに当社に通知することに同意します。

しかし、お客様は、当社のサービスの利用に関連するすべてのリスクをお客様が負うことを理解し、同意するものとし、お客様の秘密鍵の機密性およびセキュリティを維持する全責任を負うものとします。ウォレットへのアクセスまたは管理の喪失を避けるため、以下の予防措置を講じることを強くお勧めします。

a. 他で使用していない固有かつ強力なパスワードを生成すること。
b. 秘密鍵およびシークレットフレーズをオンラインのプレーンテキストまたは安全でない物理的な場所に保存しないこと。
c. デバイスおよびウォレットへのアクセスを制限すること。
d. デバイスおよびネットワーク上でのマルウェアからの保護を確保すること。
e. ウォレットに関連する既知または疑われるセキュリティ侵害について直ちに当社に通知すること。

当社は、お客様のウォレット上での活動について、お客様によって承認されたか否かにかかわらず、一切の責任を負いません。

## 13. プッシュ通知

Lumina Wallet からプッシュ通知を受け取ることを選択することにより、Lumina Wallet がサポートするブロックチェーンネットワークの混雑や、お客様のウォレットが関与する取引が完了した際に通知を受け取ることができます。これらの通知を受け取りたい場合は、「設定」メニューで「プッシュ通知」を有効にすることができます。

## 14. 第三者サービスおよびコンテンツ

当社のプラットフォームは、仮想通貨間の交換（「スワップ」）、ステーキングサービス、仮想通貨の売買、法定通貨での残高表示サービス、仮想通貨レート表示、仮想通貨の交換、貸付または借入のための分散型金融アプリケーション、NFTの視覚化、およびNFTのミント、購入、売却を含むがこれらに限定されない、当社のパートナーが提供する様々なサービスにお客様を接続します。当社はこれらの第三者サービス（以下「第三者サービス」といいます。）に対して一切の管理権限を持たないことにご留意ください。

これらのサービスおよび関連する情報コンテンツ、製品、またはサービス（以下「第三者コンテンツ」といいます。）とのお客様の関与は純粋に任意であり、かかるコンテンツへの依拠はお客様自身の責任において行われます。本契約は当社のサービスとのお客様の関与を規定しますが、第三者コンテンツおよびサービスとのお客様のやり取りは、それぞれの第三者プロバイダーによって定められた追加の利用規約に服する可能性が高いです。これらの追加条件には、別途の料金、免責事項、リスク警告、および当社とは異なるプライバシーポリシーが含まれる場合があります。これらのプロバイダーがお客様の個人情報をどのように取り扱うかを含め、これらの条件を理解し、認識することは、お客様の責任です。

第三者サービスとやり取りすることにより、お客様はプロバイダーの規約を読み、理解し、同意したことを証明します。当社は信頼できるエンティティと提携する努力をしていますが、その提供物を推奨または保証せず、またそのサービスの成功を保証するものでもありません。当社は、お客様によるこれらの第三者サービスの利用に関連するいかなる責任も否認します。

これらのサービスに関連する紛争または苦情は、それぞれの第三者プロバイダーに直接連絡すべきです。これらのサービスとのお客様のやり取りから生じる可能性のあるいかなる問題についても、当社は責任を負いません。

第三者の製品またはサービスへの言及または参照は、当社からの推奨または承認を示すものではないことに留意することが重要です。当社は、当社の裁量により、第三者サービスの提供の変更または撤回する権利を留保します。

お客様は第三者からのプッシュ通知を受け取るオプションがあります。これらの通知を受け取るためには、デバイス上で自動的に有効化されるわけではないため、お客様が明示的に同意する必要があります。

当社は、トークンの利用可能性または販売に関する情報を含むがこれらに限定されない、これらの通知を通じて提供される第三者コンテンツの有効性を保証しません。

お客様が当社のウォレットによって定義された権限内で第三者にお客様のアカウントへのアクセスを許可した場合でも、これらの規約に詳述されているいかなる責任からもお客様が免除されるわけではありません。お客様は、お客様のウォレットにアクセスする第三者のすべての行動または不行動に対して完全に責任を負います。
## 15. 支払いと手数料

本サービス、またはそのいずれかの側面に関連する手数料は、主に当社の第三者パートナーによって定められており、luminawallet.orgおよび／またはLumina Walletモバイルアプリケーションで確認できます。これらの手数料には、アカウント管理費用、取引手数料、出金手数料、ガス料金、または当社の提携事業体によって提供される特定のサービスに対する料金が含まれますが、これらに限定されません。これらの料金は第三者機関によって管理されており、当社はこれらの手数料の作成または変更にいかなる影響も与えず、また規制することもありません。

当社は、これらの手数料が、手数料の作成または調整に関して当社がいかなる管理も影響も有しない第三者機関から発生することを強調します。これらのパートナーは、独自の裁量により、手数料体系を独立して改定する権利を留保します。

特定の場合において、Lumina Walletは、第三者によって徴収されるかかる手数料から収益分配を受け取ることがあります。しかし、収益を受け取ったとしても、当社がかかる料金に対して管理または意思決定権を持つことはありません。

かかる料金体系の更新または調整は、当社のウェブサイトおよび／またはモバイルアプリケーションに速やかに反映されます。かかる更新後の本サービスの継続利用は、お客様がこれらの変更に同意したことを示します。お客様が最新の適用手数料について情報を得るために、定期的に当社のウェブサイトおよびモバイルアプリを確認することをお勧めします。

オンラインに掲載された新しい料金情報は、別途定めがない限り、即座に効力を生じます。最新の料金体系について情報を得ることはお客様の責任です。

さらに、ブロックチェーンネットワークを含む第三者サービスが追加の取引処理手数料を加える可能性があることを理解することが不可欠です。これらの追加料金は当社の管轄外であり、当社はいかなる影響も与えません。したがって、当社は第三者サービスに関連する手数料についていかなる責任も負いません。

### 取引手数料

お客様の仮想通貨取引には、お客様が利用を選択する仮想通貨システムまたはブロックチェーンネットワークによって義務付けられるマイニング手数料などの取引手数料が発生する場合があります。取引を開始する前に、お客様のウォレットに取引を完全に完了させるのに十分な残高および／または「ガス」（ネットワーク処理能力）があることを確認する責任はお客様にあります。

当社がこれらの手数料または第三者システムの料金設定メカニズムにいかなる管理も影響も有しないことを強調することが重要です。したがって、当社は、不適切に入力された取引手数料（例えば、低すぎたり高すぎたりする手数料）によりお客様が経験する可能性のあるいかなる取引の失敗または金銭的損失についても責任を負いません。これは、お客様のウォレットアドレスに関連する資金不足またはガス不足に起因するいかなる問題にも適用されます。

明確にするために、当社の非管理型（ノンカストディアル）サービスという前提により、当社はお客様または他の誰かの取引にアクセスできません。当社はいかなる取引も管理せず、いかなるウォレットに関連する秘密鍵も保持しません。

## 16. 税金

本サービスを通じたお客様の取引に関する税務上の義務は、お客様単独の責任です。お客様は、お客様の取引に適用される税金があるか否かを判断することが求められます。さらに、お客様は、正しい税額を適切な税務当局に申告し、提出する義務を負います。

当社は、当社の役割にはお客様の取引に税金が適用されるか否かを判断することが含まれないことを明示的に明確化します。当社は、デジタル資産関連の取引から生じるいかなる税金も徴収、申告、源泉徴収、または送金することを事業としていません。したがって、本サービスを通じてお客様の取引から生じるいかなる税務上の義務も、お客様と適用される税務当局との間の問題です。

## 17. 知的財産

### ライセンス

お客様が本規約に同意し遵守することを条件として、当社は、お客様に、Lumina Walletをお客様の個人的または内部事業目的のためにのみ利用するための、非独占的、サブライセンス不可、譲渡不可のライセンスを付与します。本規約に明示的に規定されていない限り、お客様は以下の行為を禁止されます。

a. Lumina Walletのいかなる部分の複製、変更、改変、または派生作品の作成。
b. Lumina Walletのリース、配布、販売、サブライセンス、譲渡、またはアクセスを可能にすること。
c. いかなる第三者の利益のためにLumina Walletを使用すること。
d. 当社の事前の書面による承認なしに、お客様が第三者に提供するいかなる製品またはサービスにLumina Walletを統合すること。
e. お客様の利用を制限するために設計されたLumina Wallet内のメカニズムを回避すること。
f. リバースエンジニアリング、逆アセンブル、逆コンパイル、翻訳、またはソースコード（画像やテキスト、基本となる概念、アルゴリズム、ファイル形式、またはLumina Walletへの非公開APIを含む）の抽出もしくは導出を試みること。ただし、法律で明示的に許可されている場合（当社に事前に通知した後）を除きます。
g. Lumina Walletに組み込まれた専有またはその他の通知を削除または不明瞭にすること。
h. 競合分析目的または競合製品を開発するためにLumina Walletを使用すること。

### フィードバック

お客様は、時折、当社にフィードバックを提供することを決定する場合があります。当社は、Lumina Walletに関連するいかなるフィードバックも、知的財産権またはその他の制限に基づく義務、ロイヤリティ、または制限なしに、いかなる方法で自由に利用、複製、開示、ライセンス供与、配布、および活用する権利を留保します。いかなるフィードバックもお客様の機密情報とはみなされず、お客様のフィードバックを組み込んでいるか否かにかかわらず、当社が製品またはサービスを独立して使用、開発、評価、または販売する権利を制限するいかなる制約も本契約にはありません。

### オープンソース

Lumina WalletはGPLオープンソースライセンスの下で運営されています。Lumina Walletの現在のソフトウェアに関する詳細は、https://github.com/LuminaWallet で確認できます。ソフトウェア開発はオープンソースの理念のもと、コミュニティによって推進されているため、誰でもアクセス可能、使用可能、および共有可能（変更された形態または未変更の形態で）です。GPLはコピーレフトライセンスとして機能し、いかなる派生作品も親ソフトウェアと同じライセンス条件で配布されなければならないことにご注意ください。

### コンテンツ

Lumina Walletには、著作権法、登録済みおよび未登録の商標、ならびにその他の知的財産権によって保護される、テキストおよびグラフィックコンテンツ（以下「コンテンツ」といいます。）を含むがこれらに限定されない、著作権で保護された素材および商標が含まれる場合があります。別途明示的に規定されていない限り、当社はコンテンツの所有権を独占的に保持します。お客様によるLumina Walletの利用は、コンテンツに対するいかなる権利、権原、または利益もお客様に付与しません。お客様は、コンテンツの全部または一部を、いかなる方法を用いるかにかかわらず、複製、再現、変更、再発行、アップロード、投稿、送信、配布、収集、販売、ライセンス供与、派生作品の作成、または利用することを差し控えることに同意します。

### NFTコンテンツへのライセンス

Lumina Walletは、非代替性トークン（以下「NFT」といいます。）の保存を促進する場合があります。お客様は、NFTに関連するコンテンツ（以下「NFTコンテンツ」といいます。）に付随する知的財産権に対する正当な所有権または許可されたアクセスを有し、したがって、Lumina WalletにNFTを保存できることを表明します。Lumina Walletに保存されたNFTコンテンツに関する全ての権利は、本規約で明示的に付与されている場合を除き、お客様に留保されます。

Lumina Walletを利用することにより、お客様は、当社に対し、Lumina Walletのサービスを促進するために必要な範囲で、NFTコンテンツにアクセス、使用、ホスト、キャッシュ、保存、複製、送信、表示、公開、配布、改変、および変更（互換性確保などの技術的目的のため、様々なデバイス間での）を行うライセンスを、あらゆるメディアまたは配布方法（現存するものまたは今後開発されるもの）を通じて付与します。

当社は、Lumina Walletに保存されたNFTおよびそれらの関連コンテンツへの不干渉のため、第三者の知的財産権侵害に対するいかなる責任も免除されます。NFT関連の全ての活動に必要なデューデリジェンスを実施する単独の責任はお客様にあり、お客様は、当社がNFTに関連するいかなるやり取りや取引についても、助言または推奨を行わないことを認識するものとします。
## 18. Lumina Wallet のご利用について

お客様は、当社のサービスのご利用が、適用されるすべての法令を完全に遵守することに同意し、これを保証するものとします。これには、お客様のご利用に関連する地方、州、連邦、国、または国際的なあらゆる法令が含まれます。お客様は、禁止された取引、違法なギャンブル、詐欺、資金洗浄、またはテロ活動を含むがこれらに限定されない、いかなる違法活動の資金提供、支援、または参加のために当社のサービスを利用しないことを約束します。

本契約は、本規約および/または銀行秘密法などの適用される法令または規制要件への違反が発見された場合、当社が本規約および法律上のすべての権利および救済措置を留保し、お客様に対して必要なすべての措置を講じることを明確にするものです。

さらに、お客様は以下の事項に同意するものとします。

1.  本セクションで禁止されている活動に、いかなる第三者も奨励または誘引しないこと。
2.  他の個人になりすまさないこと、また、許可なく他のユーザーのウォレットを承認または承認しようとしないこと。さらに、他のユーザーが当社のサービスを十分に享受することを妨げ、混乱させ、悪影響を及ぼし、または阻害するような当社のサービスの使用を控えること。
3.  Lumina Wallet を通じてウイルスまたはその他の有害なコンピューターコードを配布しないこと。
4.  当社または当社の第三者プロバイダーのインフラストラクチャに不合理または過度に大きな負荷をかける可能性のある行為を行わないこと。
5.  リバースエンジニアリングを行わないこと、また、サービスへのアクセスを防止または制限するために当社が使用するいかなる措置も回避または回避しようとしないこと。
6.  プライバシー、肖像権、知的財産権、またはその他の財産権を含む、Lumina Wallet、当社のユーザー、またはその他の第三者の権利を尊重し、侵害、不正使用、または侵害しないこと。

当社はいかなるユーザーコンテンツも監視する義務を負いませんが、お客様が本規約に違反した場合、いつでもいかなる理由でも通知なく任意の措置を開始する完全な裁量権を保持します。本規約で明示的に許可されていない、または当社の事前の書面による同意がない Lumina Wallet の使用は厳しく禁止されており、通知なくお客様の Lumina Wallet 使用ライセンスの即時終了につながります。

## 19. 責任の制限および保証の免責

お客様は、Lumina Wallet が以下の事項を管理できず、またそれに関して行動する義務も負わないことを認め、これに同意するものとします。(i) お客様による本サービスのご利用中に発生するデジタル資産の処理における潜在的な障害、中断、誤り、または遅延、(ii) ハードウェア、ソフトウェア、およびインターネット接続の障害の可能性、(iii) Lumina Wallet を支えるソフトウェアに悪意のあるソフトウェアが導入される、または発見されるリスク、(iv) お客様のウォレットアドレス、秘密鍵、およびシークレットフレーズを含むがこれらに限定されない、お客様のウォレット情報への不正な第三者アクセス、および (v) 関連するブロックチェーンネットワークにおける未知の脆弱性または予期せぬ変更のリスク。

お客様は、以下の事由から生じるいかなる損失、損害、または請求に関しても、当社を免責し、すべての責任から解放することに同意するものとします。(a) ユーザーによるエラー（パスワード忘れ、誤った取引構築、またはデジタル資産アドレスの入力ミスなど）、(b) サーバー障害またはデータ損失、(c) Lumina Wallet アプリケーションへの不正アクセス、(d) Lumina Wallet ソフトウェアのバグまたはその他の欠陥、および (e) ウイルス、フィッシング、ブルートフォース攻撃、または Lumina Wallet に対するその他の潜在的な攻撃ベクトルを含むがこれらに限定されない、許可されていない第三者の活動。

### 責任の制限

適用される法律で許容される最大限の範囲において、いかなる場合においても、当社、当社の関連会社、または当社のそれぞれの株主、会員、取締役、役員、従業員、弁護士、代理人、代表者、供給者、または請負業者は、お客様による本サービスへのアクセスまたは使用から生じる、契約、不法行為、過失、法令、厳格責任、またはその他の法理論に基づくかどうかにかかわらず、また当社がかかる損害の可能性について知らされていた場合であっても、直接損害、偶発的損害、間接損害、特別損害、懲罰的損害、結果的損害、または類似のいかなる損害または責任（データ、情報、収益、利益、その他の事業または金銭的利益の損失に対する損害を含むがこれに限定されない）についても一切責任を負わないものとします。

一部の法域では、結果的損害または偶発的損害に対する責任の除外または制限が認められていないため、上記の制限がお客様に適用されない場合があります。いかなる場合においても、お客様に対する当社のすべての損害賠償責任（人身傷害に関わる場合で適用される法律により要求される場合を除く）は、100米ドル（$USD100.00）または適用される法域の現地通貨におけるその等価額を超えないものとします。

### 保証の免責

LUMINA WALLET は「現状有姿」および「利用可能な限り」で提供され、いかなる種類の保証も伴いません。法律で許容される最大限の範囲において、当社は、本サービスおよび基盤となるソフトウェア、または情報、コンテンツ、もしくは本サービスのあらゆる側面に関して、明示的か黙示的かを問わず、すべての表明および保証を否認します。これには、当社または第三者によって提供または所有されるか、または第三者の資料や当社のウェブサイトまたは本サービスにアクセス可能またはリンクされている第三者のウェブサイトに含まれるかどうかにかかわらず、商品性、特定目的への適合性、権原、非侵害、コンピューターウイルスの不存在に関する保証、および取引の過程、履行の過程、または商習慣から生じる黙示の保証が含まれますが、これらに限定されません。これらすべては明示的に否認されます。

## 20. 補償

適用される法律で許容される範囲において、お客様は、以下から生じるあらゆる請求、損害、義務、損失、責任、不法行為、費用または債務、および経費（弁護士費用を含むがこれに限定されない）に関して、当社、当社の関連会社、および当社のそれぞれの株主、会員、取締役、役員、従業員、弁護士、代理人、代表者、供給者、および請負業者を防御し、補償し、免責することに同意するものとします。(a) お客様による本サービスの利用およびアクセス、(b) Lumina Wallet に関してお客様が当社に提供するフィードバックまたは提出物、(c) 第三者のコンテンツの違反、(d) お客様による本規約の違反、または (e) お客様によるあらゆる法令、規則、規制の違反、または第三者の権利の侵害。
## 21. 請求の制限

お客様は、当社との関係に起因または関連して発生する可能性のあるいかなる請求も、そのような請求が発生した日から1年以内に提出されなければならず、さもないと、お客様の請求は永久に棄却されることに同意します。

## 22. 終了

お客様のLumina Wallet使用ライセンスの終了の場合、本契約に基づくお客様の義務は引き続き存続します。終了後のお客様のウォレット内の資金へのアクセスは、お客様のウォレットアドレスおよび秘密鍵のバックアップへのアクセスに依存します。

## 23. サービスの停止

当社は、当社の単独の裁量により、お客様に費用を課すことなく、事前の通知の有無にかかわらず、いつでも、当社のサービスの一部を一時的または恒久的に変更または中止することができます。お客様は、ご自身のウォレットで維持するウォレットアドレスと秘密鍵のペアのバックアップを、サービス外に保管する責任を単独で負います。

お客様のウォレットに関連付けられたウォレットアドレスと秘密鍵のペアの外部バックアップを維持することにより、お客様は、お客様のウォレットが保護されているブロックチェーンネットワークにアクセスできるようになります。このようなバックアップにより、お客様はいつでも費用やデジタル資産の損失なしにウォレットを完全に復元することができます。サービス外でお客様のウォレットデータのバックアップを維持しない場合、お客様はウォレットに関連付けられたデジタル資産にアクセスできなくなります。Lumina Walletは、当社がサービスの全部または一部を中止した場合でも、デジタル資産のいかなる損失についても責任を負いません。

## 24. 放棄なし

本契約に基づく権利、権限、または特権を行使しなかったこと、またはその行使が遅れたことは、放棄を意味しません。また、権利、権限、または特権の単独または部分的な行使が、その後の他の行使を妨げるものでもありません。そのような権利または規定の放棄は、書面により、当社の正式に権限を与えられた代表者が署名した場合にのみ有効となります。本契約に明示的に定められている場合を除き、いずれかの当事者が本契約に基づく救済措置を行使しても、本契約に基づくその他の救済措置またはその他の救済措置を害することはありません。

## 25. 分離可能性

本契約の一部が、無効、法的拘束力なし、または何らかの理由で執行不能であることが判明した場合、その条項は分離可能とみなされ、必要最小限の範囲で制限または削除されます。その条項の制限または削除は、当該条項、条項または規定の残りの部分、または本規約のその他の条項、条項または規定の有効性または執行可能性に影響を与えたり、損なったりするものではありません。

## 26. 準拠法、集団訴訟の放棄および仲裁合意

### (i) 準拠法

適用法が代替を規定または提供する場合を除き、本規約（本契約の仲裁合意を含む）は、フランス法に準拠し、それに従って解釈されるものとします。

### (ii) 集団訴訟の放棄

適用法が代替の選択肢を要求または提供する場合を除き、お客様とLumina Walletは、上記の請求の通知および紛争解決期間に関する条項に従い、いかなる請求も、国際商業会議所（"ICC"）が監督する強制的、最終的、かつ拘束力のある個別の（集団訴訟ではない）仲裁によって解決されなければならず、その仲裁は、本条に参照により組み込まれるものとみなされる、その時点のICC規則に従うものとすることに同意します。

### (iii) 仲裁合意

仲裁地はフランスのパリとすることに合意します。仲裁廷は、ICC規則に従って任命される1名の仲裁人によって構成されます。仲裁の言語はフランス語または英語とします。お客様とLumina Walletはさらに、仲裁人はその管轄権（仲裁合意の存在、範囲、または有効性、または請求の仲裁可能性に関する異議を含む）についてのみ裁定する権限を有することに同意します。本条に詳述される仲裁規定は、本規約の終了後も存続します。

**請求期間:** Lumina Walletに対する仲裁を提起するには、請求を行うユーザーが、請求につながる申し立てられた行為、不作為、または不履行（「制限期間」）を最初に特定した日、または合理的に特定すべきであった日から1年以内に、ICC規則に従って仲裁通知を提出し送達しなければなりません。請求に関する仲裁通知が当該制限期間内にLumina Walletに提出され送達されない場合、ユーザーによるいかなる請求についても救済措置はありません。

**通知:** Lumina Walletがお客様に対して仲裁を開始する場合、お客様が提供した電子メールアドレスまたは郵便住所に通知を行います。お客様は、この電子メールまたは郵便住所に送信された通知が、送達の適切性に関する決定を含むすべての目的において十分であるとみなされることに同意します。Lumina Walletに登録されている電子メールアドレスおよび/または郵便住所を最新かつ正確に保つことは、お客様の義務です。

## 27. 不可抗力

当社は、天災、民事または軍事当局の行為、テロ行為、市民的または産業的騒乱、封鎖、禁輸措置、戦争、ストライキまたはその他の労働争議、火災、地震、嵐またはその他の自然関連事象、電気通信またはインターネットサービスまたはネットワークプロバイダーサービスの中断、ハードウェア機器および/またはソフトウェアの故障またはその他のユーティリティの故障、スマートコントラクトのバグまたは脆弱性、技術的変更、金利またはその他の金融状況の変更、および誤解を避けるための言及として、ブロックチェーン関連プロトコルの変更、その他の災害、または当社の合理的な支配を超えるその他の事象による遅延または故障を含みますが、これらに限定されない、当社の合理的な支配を超えるあらゆる原因または状況に直接的または間接的に起因する遅延、履行不能、またはサービスの中断について責任を負わず、残りの規定の有効性および執行可能性には影響を与えません。

## 28. 譲渡

お客様は、当社がお客様への通知または同意なしに、本規約に基づく当社の権利のいずれかを譲渡し、および/または当社の義務のいずれかを移転、下請け、または委任することに同意します。本規約は、当事者、その承継人および許可された譲受人を拘束し、その利益のために効力を生じます。本規約へのお客様の同意は、お客様個人に属するものであり、お客様はこれを第三者に移転または譲渡することはできません。
## 29. 第三者受益者の不存在

お客様は、本規約に別途明示的に定められている場合を除き、本規約にいかなる第三者受益者も存在しないことに合意します。

## 30. 完全合意

本合意は、本件主題に関する完全な理解および合意を定めるものであり、当事者間のあらゆる種類の（本規約の以前のバージョンを含みますが、これに限定されません）あらゆる性質の、従前のあらゆる議論、合意および理解に優先します。上記に定める場合を除き、本規約のいかなる修正も書面によるものとし、両当事者が署名しなければなりません。

## 31. 通知

当社が本規約に基づき提供する、本規約の修正に関するものを含むあらゆる通知またはその他の連絡は、サービスへの掲載および／またはその他の電子的通信を通じて行われます。お客様は、お客様のアカウントおよびサービスの利用に関連して当社が提供する、すべての連絡、合意、文書、通知および開示を電子的方法で受領することに同意し、承諾します。

## 32. 質問またはコメント

本規約、本規約から生じるお客様の権利および義務、および／またはLumina Walletと当社のサービスの利用、またはその他の事項に関してご質問がある場合、当社の連絡ページ**support@luminawallet.org**までメッセージをお送りください。`,
  },
};

export default ja;
